module.exports = __webpack_public_path__ + "static/img/china.fa4401d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/china.png
// module id = zqLF
// module chunks = 1